import { combineReducers } from 'redux'
import UploadFile from './uploadFile/uploadFile.reducer'
import user from './slice/user';
import socketSlice from './slice/socketSlice';
const rootReducer = combineReducers({
  UploadFile,
  user,
  socketSlice,
})

export default rootReducer
